import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { PLANS } from "@/config/plans";

interface FaqItem {
  question: string;
  answer: string;
}

export function FAQ() {
  const { t } = useTranslation("landing");
  const items = t("faq.items", {
    returnObjects: true,
    days: PLANS.beta.retentionDays,
  }) as FaqItem[];

  return (
    <section
      id="faq"
      className="mx-auto grid max-w-[1200px] scroll-mt-24 gap-10 px-5 pt-24 md:px-10 md:pt-32 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14"
    >
      <div>
        <p className="text-sm font-semibold text-primary">{t("faq.eyebrow")}</p>
        <h2 className="mt-3 text-4xl font-bold tracking-[-0.04em] md:text-5xl">{t("faq.title")}</h2>
      </div>
      <Accordion type="single" collapsible className="border-t border-border">
        {items.map((item, i) => (
          <AccordionItem key={item.question} value={`q${i}`}>
            <AccordionTrigger className="py-5 text-[15px] font-medium hover:no-underline">
              {item.question}
            </AccordionTrigger>
            <AccordionContent className="text-[15px] leading-relaxed text-muted-foreground">
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
